import evaluateListFilter from "./evaluateListFilter";

const getFilteredListIndex = (
  item: Record<string, unknown>,
  expression: string,
  checkfield: string,
  list: Array<Record<string, unknown>>,
): number | undefined | null => {
  if (item._associatedWithId) {
    return null;
  }
  const filteredList = list.filter((element) => evaluateListFilter(element, expression, checkfield) && !element._associatedWithId);
  const index = filteredList.indexOf(item) + 1;
  return index || undefined;
};
export default getFilteredListIndex;